var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitFullscreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06578e-07 1.12681L3.7183 4.84511L4.84511 3.7183L1.12681 0L5.06578e-07 1.12681Z",
    fill: "#6A84C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80283 6.76056L6.76056 1.80283V6.76056H1.80283Z",
    fill: "#6A84C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.8732L12.2817 11.1549L11.1549 12.2817L14.8732 16L16 14.8732Z",
    fill: "#6A84C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1972 9.23944L9.23944 14.1972V9.23944H14.1972Z",
    fill: "#6A84C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.12681L12.2817 4.84511L11.1549 3.7183L14.8732 0L16 1.12681Z",
    fill: "#6A84C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1972 6.76056L9.23951 1.80283V6.76056H14.1972Z",
    fill: "#6A84C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.8732L3.7183 11.1549L4.84511 12.2817L1.12681 16L0 14.8732Z",
    fill: "#6A84C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80276 9.23944L6.76049 14.1972V9.23944H1.80276Z",
    fill: "#6A84C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullscreenIcon);
export default __webpack_public_path__ + "static/media/exit-fullscreen-icon.81b41f4546d21e904b46b68896de06c6.svg";
export { ForwardRef as ReactComponent };